export default __webpack_public_path__ + "static/media/wallmart2.f4554fb9.png";